import customHeaders, { getSpace } from '../../common/headers';
import { useState, useEffect, useRef } from 'react';
import { TableBox, ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { useDataTable } from '../../common/hooks';
import useGeneralStore from '../../store/general';
import './AddCompetitors.scss';
import { ModalAddMpSimple } from '../../components/Modal/ModalAddMpSimple/ModalAddMpSimple';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { useResponseHandler } from '../../common/auth';

const AddCompetitors = ({ }) => {

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();

  // Таблица
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort, setCustomHeaders } = setTableFuncs;

  const [currentCompetitor, setCurrentCompetitor] = useState(null)

  const [isModalAddMpSimple, setIsModalMpSimple] = useState(false);

  // Таблица товаров для ИИ анализа
  const fetchTableData = (params, abortController = new AbortController()) => {
    let sort;
    let filtersParam = [];

    if (params) {
      [sort, filtersParam] = params;
    }

    // Устанавливаем loading в true только если запрос не прерван
    if (!abortController.signal.aborted) {
      setLoading(true);
    }

    let url = `https://appche1.ecomru.ru:4348/api/products${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`;

    const body = JSON.stringify({
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
      filters: filtersParam
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      });
  };

  const onAction = (e) => {
    setCurrentCompetitor(e)
    setIsModalMpSimple(true)
  }

  useEffect(() => {
    if (!isModalAddMpSimple) {
      setTimeout(() => fetchTableData([]), 0)
    }
  }, [isModalAddMpSimple]);

  return (
    <>
      {isModalAddMpSimple && (
        <ModalAddMpSimple
          currentCompetitor={currentCompetitor}
          setCurrentCompetitor={setCurrentCompetitor}
          setIsModal={(e) => setIsModalMpSimple(e)} />
      )}

      <div className="add-competitors">
        <TitlePage
          title='Добавить конкурентов'
        />

        <ButtonBasic
          green
          text="Создать товар"
          onClick={(e) => {
            setIsModalMpSimple(true);
          }}
        />

        <TableBox
          {...tableProps}
          paginator={true}
          ref={paginatorRef}
          fetchCallback={fetchTableData}
          onAction={onAction}
        />
      </div>
    </>
  );
};

export { AddCompetitors };
